<template>
    <router-link
        v-if="available"
        :to="{ name: 'OperatorWorkspace' }"
        class="workspace-link"
        title="Общая очередь компаний"
    >
        Рабочее место
    </router-link>
</template>
<script>
export default {
    name: 'WorkspaceLink',
    computed: {
        available() {
            return this.$store.state.operatorWorkspace.companies.length > 0
        },
    },
}
</script>
<style scoped lang="scss">
@use 'sass:color';
@use '@scss/variables' as *;

.workspace-link {
    padding: 8px 11px;
    background: color.mix($global-yellow, $global-white, 20%);
    border: 1px solid color.mix($global-yellow-light, $global-white, 80%);
    border-radius: 8px;
    font-size: 12px;
    color: color.mix($global-yellow, $global-black, 35%);
    white-space: nowrap;

    &:hover {
        background: color.mix($global-yellow, $global-white, 50%);
    }
}
</style>
